module.exports = __webpack_public_path__ + "static/img/profit.6071c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profit.png
// module id = 254
// module chunks = 1